import { useMemo } from 'react';
import { HardDrive } from 'lucide-react';
import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { iconSize } from '@duke-hq/ui/constants/scalable';

const SIZE_OPTIONS = [
  { id: '0-1mb', value: '0-1mb', label: '< 1 MB' },
  { id: '1-10mb', value: '1-10mb', label: '1-10 MB' },
  { id: '10-100mb', value: '10-100mb', label: '10-100 MB' },
  { id: '100mb+', value: '100mb+', label: '> 100 MB' },
];

export function SizeFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const selected = useMemo(() => {
    const sizeRange = filters['sizeRange'] ?? [];
    const validIds = new Set(SIZE_OPTIONS.map(({ id }) => id));
    return sizeRange.filter((id: string) => validIds.has(id));
  }, [filters]);

  return (
    <MultipleChoiceFilter
      items={SIZE_OPTIONS}
      label="Size"
      name="sizeRange"
      onFilterChange={({ sizeRange }) => updateFilters({ sizeRange })}
      onlyUpdateOnChange
      value={selected.join(',')}
      variant="ghost"
      leftIcon={<HardDrive size={iconSize.md} />}
      rightIcon={undefined}
    />
  );
}
